import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { forkJoin, from, Observable, Subscription } from 'rxjs';

import {
  ExcelExportComponent,
  WorkbookSheetColumn,
  WorkbookSheetRow
} from "@progress/kendo-angular-excel-export";
import {
  CompositeFilterDescriptor,
  process,
  State,
  DataResult,
  GroupResult,
  groupBy,
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  ColumnComponent,
} from "@progress/kendo-angular-grid";


import {
  ScreenListsService,
  SharedDataService,
  LoggedUserService,
  ContactsService,
  Family,
  ContactStoredData,
  SimpleReponseResult,
  SearchContactsParameters,
  WFMotif,
  SourcingParameters,
  PS_Sourcing_Result,
  Contact,
  Ps_LstPerimeters_XRP_Result,
  PafDocument,
  PS_Lib_Report_Et_Form_Result,
  RseQuestion
} from 'ngx-paf-common';

import moment from 'moment';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { Department } from 'ngx-paf-common';
import { DomSanitizer } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { delay, switchMap, map, tap, take, debounceTime, distinctUntilChanged } from 'rxjs/operators';

type FamilyExtended = Family & {
  Display?: string;
  searchField?: string;
};

@Component({
  selector: 'sourcing',
  templateUrl: './sourcing.component.html',
  styleUrls: ['./sourcing.component.scss'],
})
export class SourcingComponent implements OnInit, AfterViewInit, OnDestroy {

  filters: SourcingParameters = new SourcingParameters();
  lstFamilies: FamilyExtended[] = [];
  lstFamiliesFiltered: FamilyExtended[];
  lstRseQuestions: RseQuestion[] = [];
  selectedFamilies: Family[] = [];
  familySearchMask: string = '';
  etbFilterText = '';
  
  lstMotifs: WFMotif[] = [];
  lstDepartments: Department[] = [];
  lstRegions: Department[] = [];
  lstPafDocuments: PafDocument[] = [];
  filteredPafDocuments: any[] = [];
  pafDocSearchMask: string = '';
  Labels: PS_Lib_Report_Et_Form_Result[] = [];
  lstPerimeters: Ps_LstPerimeters_XRP_Result[]
  lstEtatDocumentaire: string[] = ['vert', 'orange', 'rouge'];
  userDatas: ContactStoredData[] = [];
  visibleFilters: boolean = true;
  suppliers: PS_Sourcing_Result[];

  subscriptions: Subscription[] = [];

  gridData: DataResult;
  state: State = {
    skip: 0,
    take: 100
  };
  public gridPageableSettings: any = {
    pageSizes: [10, 20, 50, 100],
    position: 'top'
  }
  @ViewChild('ngfrmSourcingFilters') frmSourcingFilters: NgForm;
  @ViewChild("lstFamiliesCbo") public multiselectFamilies: MultiSelectComponent;
  @ViewChild("CertOrQualifDocIds") public multiselectPafdoc: MultiSelectComponent;

  constructor(
    private screenListsSvc: ScreenListsService,
    private contactsSvc: ContactsService,
    public sharedDataSvc: SharedDataService,
    private loggedUserSvc: LoggedUserService,
    private sanitizer: DomSanitizer) {
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit(): void {
    if (!this.sharedDataSvc.allListsLoaded) {
      this.subscriptions.push(this.sharedDataSvc.allListsLoadedChange
        .subscribe(() => {
          this.bindGlobalListsToLocalLists();
          this.reloadVariableLists();
        }));
    } else {
      this.bindGlobalListsToLocalLists();
      this.reloadVariableLists();
    }
    this.sharedDataSvc.loggedProfilChange.subscribe(res => {
      this.reloadVariableLists();
    });

  }

  bindGlobalListsToLocalLists(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.lstFamilies = this.sharedDataSvc.families.map(f => {
        let fExt = {
          ...f,
          Display: this.familyLabel(f),
          searchField: this.familyLabel(f).toLowerCase().removeAccents()
        };
        return fExt;
      });
      this.lstFamilies.sortObject('Display');
      this.lstFamiliesFiltered = [...this.lstFamilies];
      this.lstMotifs = this.sharedDataSvc.wfMotifs.map(f => ({ ...f }));
      this.lstPafDocuments = this.sharedDataSvc.pafDocuments.filter(doc => doc.Screen == 'REGUL' || doc.Screen.indexOf('QUALITY/') >= 0).map(f => ({ ...f }));
      this.lstPafDocuments.forEach(d => {
        if (d.Screen == "REGUL") {
          (<any>d).sortOrder = 1;
          (<any>d).groupPrefix = 'Doc. Réglementaires - ';
        } else if (d.Screen == "QUALITY/QUALIF") {
          (<any>d).groupPrefix = '';
          (<any>d).sortOrder = 2;
        } else if (d.Screen == "QUALITY/OTHERS") {
          (<any>d).groupPrefix = '';
          (<any>d).sortOrder = 3;
        }
        (<any>d).traduction = this.sharedDataSvc.getLoadedLabel(d.LblCod);
        (<any>d).groupLib = (<any>d).groupPrefix + this.sharedDataSvc.getLoadedLabel(d.DocTyp.LblCod);
      });
      this.lstPafDocuments.sortObject(['sortOrder', 'DisplayRank']);
      this.filteredPafDocuments = this.groupKendoDatas(this.lstPafDocuments, 'groupLib');
      this.lstMotifs.forEach((s: WFMotif) => {
        (<any>s).Display = this.sharedDataSvc.getLoadedLabel(s.LblCod);
      });
      resolve();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initFamiliesFilters();
      this.initPafDocFiters();
    }, 0);

  }

  public get exportButtonDisabled(): boolean {
    return this.frmSourcingFilters?.dirty || (this.suppliers || []).length == 0;
  }


  public familyClass(dataItem: Family, indented: boolean = false): any {
    let ngClass: any = this.sharedDataSvc.familyClass(dataItem.Id);
    if (indented) {
      let familyLevel: number = this.sharedDataSvc.familyLevel(dataItem.Id) + 1;
      ngClass['ml-' + familyLevel.toString()] = true;
    }
    return ngClass;
  }

  public familyLabel(dataItem: Family): string {
    return this.sharedDataSvc.familyLabel(dataItem.Id, true);
  }
  public familyIcon(dataItem: Family): any {
    return this.sharedDataSvc.familyIcon(dataItem.Id);
  }
  public familyIconClass(dataItem: Family): any {
    return this.sharedDataSvc.familyIconClass(dataItem.Id);
  }

  get excelExportFileName(): string {
    let curDate: string = moment().format('DD-MM-YYYY-HHmm');
    return 'Sourcing ' + curDate + '.xlsx';
  }

  get RseQuestionColumns(): any[] {
    return this.lstRseQuestions.filter(q => !!q.LblCodShort).map(q => {
      return {
        field: `RSE_${q.Id}`,
        getTitle: () => this.sharedDataSvc.getLabel(q.LblCodShort)
      };
    })
  }

  public groupKendoDatas(datas: any[], groupingProperty: string): GroupResult[] {
    return groupBy(datas, [{ field: groupingProperty }]);
  }



  initPafDocFiters() {
    this.multiselectPafdoc.filterChange
      .asObservable()
      .pipe(tap(value => this.pafDocSearchMask = value))
      .pipe(
        switchMap(value =>
          from([this.lstPafDocuments]).pipe(

            delay(100), map(data => data.filter(item => (<any>item).traduction.toLowerCase().removeAccents().indexOf(value.toLowerCase().removeAccents()) !== -1))
          )
        )
      ).subscribe(results => {
        this.filteredPafDocuments = this.groupKendoDatas(results, 'groupLib');
      });
  }

  initFamiliesFilters() {
    this.multiselectFamilies.filterChange.pipe(
    debounceTime(250),   
    distinctUntilChanged(), 
    tap(search => {
      // garde la version brute pour la surbrillance
      this.familySearchMask = search;
    }),
    map(search => search.toLowerCase().removeAccents()),
    map(search =>
      this.lstFamilies
        .filter(entry => entry.searchField.includes(search))
        .slice(0, 200) // limite le nombre de résultats
    )
  )
  .subscribe(results => {
    this.lstFamiliesFiltered = results;
  });
  }

  reloadVariableLists(callBack: () => any = null): void {
    this.userDatas = [];
    this.lstPerimeters = [];;
    forkJoin([
      this.loggedUserSvc.LoggedUserStoredDatas(),
      this.loggedUserSvc.LstPerimeters(),
    ]).subscribe(results => {
      this.userDatas = results[0];
      this.lstPerimeters = results[1];
      this.filteredPerimeters = [...this.lstPerimeters];
      this.etbFilterText = '';
      this.loadFilters();
      if (callBack) callBack();
    }
    );
  }


  loadFilters(): void {
    if (this.userDatas.some(ud => ud.Key == 'SOURCING-FILTERS')) {
      this.filters = JSON.parse(this.userDatas.find(ud => ud.Key == 'SOURCING-FILTERS').Datas);
      this.selectedFamilies = this.lstFamilies.filter(s => this.filters.FamiliesIds.indexOf(s.Id) >= 0);
      if (this.filters.SupplierContactMask) {
        this.SupplierContactFilterChange(this.filters.SupplierContactMask);
      }
    }
    if (this.userDatas.some(ud => ud.Key == 'SOURCING-GRIDSTATE')) {
      this.state = JSON.parse(this.userDatas.find(ud => ud.Key == 'SOURCING-GRIDSTATE').Datas);
    }
  }

  storeFilters(): Observable<[SimpleReponseResult, SimpleReponseResult]> {
    return forkJoin([
      this.loggedUserSvc.StoreDatas('SOURCING-FILTERS', this.filters),
      this.loggedUserSvc.StoreDatas('SOURCING-GRIDSTATE', this.state)
    ]);
  }

  toggleDisplayFilters(): void {
    this.visibleFilters = !this.visibleFilters;
  }

  get gridHeight(): number {
    return this.visibleFilters ? 450 : 700;
  }

  public reinit() {
    this.suppliers = [];
    this.selectedFamilies = [];
    this.state = {
      skip: 0,
      take: 100
    };
    this.gridData = <DataResult>process(this.suppliers, this.state);
    this.filters = new SourcingParameters();
    this.filters.TopESAT=0;
  }

  public triStateLib(item: number): string {
    switch (item) {
      case 0: return 'Non';
      case 1: return 'Oui';
      case 2: return 'NR';
      default: return 'NC';
    }
  }

  private mapItem(item: PS_Sourcing_Result): PS_Sourcing_Result {
    (<any>item).IsHQ2 = (item.IsHQ == 1);
    (<any>item).IsNucleaire = this.triStateLib(item.TopNucleaire);
    (<any>item).IsSurSite = this.triStateLib(item.TopSurSite);
    (<any>item).IsESAT = this.triStateLib(item.TopEsat);
    (<any>item).IsEA = this.triStateLib(item.TopEA);
    (<any>item).IsTIH = this.triStateLib(item.TopTIH);
    (<any>item).FunctionalLib = item.FunctionalId + ' : ' + item.UniqueId;
    (<any>item).FamiliesHtml = this.sanitizer.bypassSecurityTrustHtml(this.getFamiliesCellDisplay(item));
    (<any>item).FamiliesDisplay = this.getFamiliesDisplay(item);
    (<any>item).TakSegment = this.takapaSegment(item);
    (<any>item).TakFamily = this.takapaFamily(item);
    (<any>item).TakSubFamily = this.takapaSubfamily(item);
    (<any>item).legalFormLib = this.getLegalFormLib(item);
    (<any>item).excelRSEColor = this.indicateurRSEExcelColor(item)
    let extendDatas: any = {};
    extendDatas.Families = this.getFamiliesExcelDisplay(item);
    extendDatas.apeCod = this.getApeCod(item);
    extendDatas.apeLib = this.getApeLib(item);
    extendDatas.adresse = ((item.AddrNum || '') + ' ' + (item.Addr1 || '') + ' ' + (item.Addr2 || '') + ' ' + (item.Addr3 || '') + ' ' + (item.Addr4 || '')).trim();
    extendDatas.MotifValid = (<any>this.lstMotifs.find(m => m.Id == item.MotifValId))?.Display;
    extendDatas.OrderCurrency = this.sharedDataSvc.currencies.find(c => c.Id == item.OrderCurId)?.Cod;
    extendDatas.isAffacturage = (item.TopAffacturage == 1);
    extendDatas.facAddress = (
      (item.FacAddrNum || '')
      + ' '
      + ((item.FacAddr1 || '')
        + ' ' + (item.FacAddr2 || '')
        + ' ' + (item.FacAddr3 || '')
        + ' ' + (item.FacAddr4 || '')).trim()
      + ' ' + (item.FacPostalCod || '') + ' '
      + (item.FacCity || '')).trim();
    extendDatas.isFacDemat = (item.TopFacDemat == 1);
    for (let i: number = 1; i <= 5; i++) {
      extendDatas['SuppContAccesPaf' + i] = this.triStateLib((<any>item)['SuppContAccesPaf' + i]);
    }

    extendDatas.TopEnZone = this.triStateLib(item.TopEnZone);
    extendDatas.TopFormationRadio = this.triStateLib(item.TopFormationRadio);
    extendDatas.TopEtrangers = this.triStateLib(item.TopEtrangers);
    extendDatas.TopAssDec = this.triStateLib(item.TopAssDec);
    (<any>item).extendDatas = extendDatas;
    return item;
  }

  getFamiliesDisplay(item: any): string {
    let families: Family[] = this.lstFamilies
      .filter(f => (item.FamiliesIds || '').split('|').indexOf(f.Id.toString()) >= 0);

    return families.map(f => (<any>f).Display).join(' ');
  }

  public reloadDatas(): Observable<PS_Sourcing_Result[]> {
    if (!this.topExportFullAllowed) this.filters.TopExcelFull = false;
    return this.screenListsSvc.Sourcing({...this.filters})
      .pipe(
        map((items: PS_Sourcing_Result[]) => {
          items.forEach((item: PS_Sourcing_Result) => this.mapItem(item));
          return items;
        })
      );
  }

  public search(): void {
    this.storeFilters()
      .subscribe({
          next:response => {
            this.sharedDataSvc.WindowLock();
            this.reloadDatas().subscribe(res => {
              this.suppliers = res;
              if ((this.state.skip || 0) > res.length) {
                this.state = {
                  skip: 0,
                  take: 10
                };
              }
              this.gridData = process(this.suppliers, this.state);
              this.sharedDataSvc.WindowUnlock();
              setTimeout(() => {
                this.frmSourcingFilters?.form?.markAsPristine();
              }, 0);
            });
          },
          error: err => this.sharedDataSvc.alert(err.message || err)
        });
  }


  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.suppliers, this.state);
  }

  // Si 1 case cochée, sinon case non cochée
  checkNgClass(fieldValue: number): any {
    return {
      'far': true,
      'fa-check-square': (fieldValue == 1),
      'fa-square': (fieldValue != 1),
    }
  }

  // Si 0 : case non cochée, 1 case cochée, sinon case pleine
  checkTriStateNgClass(fieldValue: number): any {
    return {
      'fas': (fieldValue || 2) >= 2,
      'far': (fieldValue || 2) < 2,
      'fa-check-square': (fieldValue == 1),
      'fa-square': (fieldValue != 1),
    }
  }

  get excelDatas(): any[] {
    return this.suppliers || [];
  }

  selectedRow: PS_Sourcing_Result = null;

  getUniqueNum(item: PS_Sourcing_Result): string {
    let key = Object.keys(item).find(k => k.toLowerCase() == item.FunctionalId.toLowerCase());
    return key ? (<any>item)[key] : "";
  }
  getAddr(item: PS_Sourcing_Result): string {
    return ((item.AddrNum || '') + ' ' + (item.Addr1 || '') + ' ' + (item.Addr2 || '') + ' ' + (item.Addr3 || '') + ' ' + (item.Addr4 || '')).trim();
  }
  getAddrAffacturage(item: PS_Sourcing_Result): string {
    return ((item.FacAddrNum || '') + ' '
      + (item.FacAddr1 || '') + ' '
      + (item.FacAddr2 || '') + ' '
      + (item.FacAddr3 || '') + ' '
      + (item.FacAddr4 || '') + ' '
      + (item.FacPostalCod || '') + ' '
      + (item.FacCity || '')).trim();
  }

  getApeCod(item: PS_Sourcing_Result): string {
    return this.sharedDataSvc.lstApeCods.find(a => a.Id == item.ApeId)?.Cod;
  }
  getApeLib(item: PS_Sourcing_Result): string {
    return this.sharedDataSvc.lstApeCods.find(a => a.Id == item.ApeId)?.LblCod;
  }

  getLegalFormLib(item: PS_Sourcing_Result): string {
    return (<any>this.sharedDataSvc.legalForms.find(a => a.Id == item.LegalFormId))?.LblCod;
  }

  isSiegeDisplay(item: PS_Sourcing_Result): Observable<string> {
    return this.sharedDataSvc.getLabel(item.IsHQ == 1 ? 'Oui' : 'Non');
  }

  //---------------------------------------
  // Auto completion du 1er valideur
  public contactValidator: Contact;
  validatorOrAchRefIdList: Observable<Contact[]>;

  public validatorOrAchRefIdFilterChange(searchmask: any): void {
    let profilsIds: number[] = this.sharedDataSvc.lstProfils
      .filter(p => ['ACH_OPERAT', 'ACH_OPERAT_2', 'ACH_FAMHA', 'ADMIN'].indexOf(p.Cod) >= 0)
      .map(p => p.Id);
    let parameters: SearchContactsParameters = new SearchContactsParameters();
    parameters.SearchMask = searchmask;
    parameters.Profils = profilsIds;
    this.validatorOrAchRefIdList = this.contactsSvc.searchContacts(parameters);
  }


  //---------------------------------------



  //---------------------------------------



  //---------------------------------------
  //Liste des contacts fournisseurs
  @ViewChild("lstSupplierContactsCbo") lstSupplierContactsCbo: MultiSelectComponent;
  SupplierContactSearchMask: string = '';
  supplierContactIdList: Observable<Contact[]>;
  public SupplierContactFilterChange(searchmask: any): void {
    let parameters: SearchContactsParameters = new SearchContactsParameters();
    parameters.SearchMask = searchmask;
    parameters.SupplierContact = true;
    this.supplierContactIdList = this.contactsSvc.searchContacts(parameters);
  }

  //---------------------------------------


  public highlightSearch(display: string, search: string): string {
    if (!display || !search) return display;
    let startIndex: number = display.toLowerCase().removeAccents().indexOf(search.toLowerCase().removeAccents());
    if (startIndex < 0) return display;

    let endIndex = startIndex + search.length;
    return [
      display.slice(0, startIndex),
      '<mark>',
      display.slice(startIndex, endIndex),
      '</mark>',
      display.slice(endIndex)
    ].join('');
  }

  getFamiliesCellDisplay(item: any): string {
    let families: Family[] = this.lstFamilies
      .filter(f => (item.FamiliesIds || '').split('|').indexOf(f.Id.toString()) >= 0);
    if (families.length == 0) return '';
    let ret: string[] = ['<div class="d-flex flex-column" style="width:100;">'];
    families.forEach(f => {
      ret.push('<div style="width:100%;" class="'
        + this.familyCellClass(f.Id) + '">'
        + (<any>f).Display
        + '</div>');
    })
    ret.push('</div>');
    return ret.join('');
  }
  gridArrayHtmlDisplay(items: any[]): string {
    if (!items || items.length == 0) return '';
    return items.filter(item => (item || '').toString() != '').map(item => '<DIV style="width:100%;">' + item.toString() + '</DIV>').join('');
  }
  gridArraySearch(items: any[]): string {
    if (!items || items.length == 0) return '';
    return items.filter(item => (item || '').toString() != '').join(' ');
  }

  getFamiliesExcelDisplay(item: any): string {
    let families: Family[] = this.lstFamilies
      .filter(f => (item.FamiliesIds || '').split('|').indexOf(f.Id.toString()) >= 0);
    if (families.length == 0) return '';
    return families.map(f => (<any>f).Display).join('\n');
  }

  public familyCellClass(familyId: number): any {
    let ngClass: any = this.sharedDataSvc.familyClass(familyId);
    let ret: string[] = [];
    Object.keys(ngClass).forEach((k: string) => {
      if (ngClass[k]) ret.push(k);
    });
    let familyLevel: number = this.sharedDataSvc.familyLevel(familyId) + 1;
    ret.push('ml-' + familyLevel.toString());
    return ret.join(' ');
  }

  public getDocStateImg(): string {
    return './assets/images/trafficLight.png';
  }

  public getDocStateImgClass(state: string): string {
    if (!state) return '';
    return 'img-docstate-' + state.toLowerCase();
  }

  MainFamily(dataItem: PS_Sourcing_Result): Family | undefined {
    return this.lstFamilies.find(f => f.Id == dataItem.MainFamilyId)
  }

  public takapaSegment(dataItem: PS_Sourcing_Result): string {
    return this.MainFamily(dataItem)?.TakFamily || '';
  }

  public takapaFamily(dataItem: PS_Sourcing_Result): string {
    return this.MainFamily(dataItem)?.TakSubTyp || '';
  }

  public takapaSubfamily(dataItem: PS_Sourcing_Result): string {
    return this.MainFamily(dataItem)?.TakSubTyp2 || '';
  }

  public topNucleaire(dataItem: PS_Sourcing_Result): any {
    return dataItem.TopNucleaire == 1 ? 'O' : 'N';
  }
  public TopSurSite(dataItem: PS_Sourcing_Result): any {
    return dataItem.TopSurSite == 1 ? 'O' : 'N';
  }

  getRandomTrafficLightHtml(dataItem: PS_Sourcing_Result, column: ColumnComponent = null): string {
    let modulo: number = (column ? column.leafIndex : 0) % 3;
    if (dataItem) {
      modulo = (modulo + (dataItem.Id)) % 3;
    }
    let retString: string =
      '<div class="img-docstate-container">' +
      '<img src="' + this.getDocStateImg() + '" class="img-docstate img-docstate-{0}" />' +
      '</div>';
    //on ajoute une valeur arbitraire pour les tests en debug
    if (!(<any>dataItem)[column.field]) {
      (<any>dataItem)[column.field] = modulo == 0 ? 'rouge' : modulo == 1 ? 'orange' : 'vert';
    }
    if (modulo == 0) {
      return retString.replace('{0}', 'rouge');
    } else if (modulo == 1) {
      return retString.replace('{0}', 'orange');
    } else {
      return retString.replace('{0}', 'vert');
    }
  }

  public trafficLightHtml(dataItem: PS_Sourcing_Result, column: ColumnComponent): any {
    if (!dataItem || !column) return '';
    if (!(<any>dataItem)[column.field] && !this.sharedDataSvc.debug) return '';
    return this.getRandomTrafficLightHtml(dataItem, column);
  }


  //-------------------------------------
  // Filtres sur Grid

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.state.filter = filter;
    let filterDatas: PS_Sourcing_Result[] = this.suppliers;
    this.gridData = process(filterDatas, this.state);
  }


  public excelExportClick(component: ExcelExportComponent): void {
    this.search()
    const options = component.workbookOptions();
    let header: WorkbookSheetRow = options.sheets[0].rows.find(r => r.type == 'header');

    if (header) {
      let familyColIndexes: number[] = [];
      const cols = options.sheets[0].columns;
      cols.forEach((col: WorkbookSheetColumn, i: number) => {
        switch (header.cells[i].value) {
          case 'Savoir-faire':
          case 'Takapa Segment':
          case 'Takapa Famille':
          case 'Takapa sous-famille':
            familyColIndexes.push(i);
            break;
          default:
            col.autoWidth = true;
            break;
        }
        if (this.RseQuestionColumns.some(q => q.field == header.cells[i].value)) {
          header.cells[i].value = this.RseQuestionColumns.find(q => q.field == header.cells[i].value).getTitle();
        }
      });
      familyColIndexes.forEach((i: number) => {
        options.sheets[0].rows.forEach(row => {
          row.cells[i].wrap = true;
        });
      });
    }

    component.save(options);
  }
  public get canExport(): boolean {
    return this.sharedDataSvc.checkProfilAccessPafSettings('Sourcing_CanExport');
  }



  public indicateurClass(indicateurCod: string): string {
    switch ((indicateurCod || '').toLowerCase()) {
      case 'vert':
        return 'indicateur indicateur-vert';
      case 'orange':
        return 'indicateur indicateur-orange';
      case 'rouge':
        return 'indicateur indicateur-rouge';
      case 'bleu':
        return 'indicateur indicateur-bleu';
      case 'gris':
        return 'indicateur indicateur-gris';
      default:
        return 'indicateur indicateur-nc';
    }
  }

  public indicateurRSEClass(item: PS_Sourcing_Result): string {
    switch (item?.IndRSEColorId) {
      case 0:
        return '';
      case 1:
        return 'indicateur indicateur-vert';
      case 2:
        return 'indicateur indicateur-orange';
      case 3:
        return 'indicateur indicateur-rouge';
      default:
        return '';
    }
  }

  public indicateurRSEExcelColor(item: PS_Sourcing_Result): string {
    switch (item?.IndRSEColorId) {
      case 0:
        return '';
      case 1:
        return 'vert';
      case 2:
        return 'orange';
      case 3:
        return 'rouge';
      default:
        return '';
    }
  }

  public rseTooltip(item: PS_Sourcing_Result): string {
    if (item.IndRSEColorId == 0) return '';
    return `Note RSE : ${item.IndRSE.toString()} / 100`;
  }

  public getSupplierLink(item: any): string {
    if (!(item || {}).Id) return '';
    return '/supplier-details/' + item.Id + '/sourcing';
  }

  public get topExportFullAllowed(): boolean {
    return this.sharedDataSvc.profil?.Cod == 'ADMIN';
  }

  etbIsSelected(value: any): boolean {
    return this.filters?.RegionalPanels?.some(s=>s==value);
  }

  public filteredPerimeters: any[] = [];


onEtbFilterChange(value: string): void {
  this.etbFilterText = value;

  this.filteredPerimeters = this.lstPerimeters.filter(item =>
    !value || item.EtbLib.toLowerCase().indexOf(value.toLowerCase())>=0);
}

highlight(text: string): string {
  if (!this.etbFilterText) {
    return text;
  }
  const escaped = this.etbFilterText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escaped})`, 'gi');
  return text.replace(regex, `<span class="highlight">$1</span>`);
}


}
